// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8fb2a643","455":"fda1e54b"}[chunkId] + ".chunk.js";
};